import React from 'react'

export const PageTitle = ({ title }) => {
  return (
    <div className='page-title-container'>
        <strong>{ title }</strong>
      </div>
  )
}
